import React from 'react';
import PropTypes from "prop-types";

import './radio-button.component.scss';

function RadioButton(props) {

    const { checked, onChange, onClick, onBlur, children, radioButtonClass, radioButtonContainerClass, ...otherProps } = props;

    return (
        <div className={radioButtonContainerClass}>
            <label className="radioButtonLabel">
                <input 
                    {...otherProps}
                    type="radio" 
                    onChange={e => onChange(e.target.checked)}
                    onClick={onClick}
                    onBlur={onBlur}
                    className={radioButtonClass}
                    checked={checked}
                />
                <span className="customRadioButtonIcon">
                    {children}
                </span>
            </label>
        </div>
    )
}

RadioButton.defaultProps = {
    onChange: () => {},
    onClick: e => e.stopPropagation(),
    radioButtonClass: "radioButton",
    radioButtonContainerClass: "b2b-lib-radioButtonContainer"
}

RadioButton.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    radioButtonClass: PropTypes.string,
    radioButtonContainerClass: PropTypes.string
}

export default RadioButton